import _, { template } from 'lodash';
import createjs from 'createjs-collection';
import { cjsDraw } from '../cjsRoot/cjsDraw.js';

export class cjsTraceDraw extends cjsDraw {
  _active;
  _color;
  _erase;
  _traceErase;
  _steps;
  _panel;

  constructor(obj) {
    super(obj);
    this._active = false;
    this._erase = false;
    this._traceErase = [];
    this._steps = [];
    this._panel = false;
  }

  changeColor(val) {
    this._color = val;
    cjsTraceDraw.redraw(this._stage);
  }

  set active(v) {
    this._active = v;
  }

  get active() {
    return this._active;
  }

  set panel(v) {
    this._panel = v;
  }

  get panel() {
    return this._panel;
  }

  set color(v) {
    this._color = v;
  }

  get color() {
    return this._color;
  }

  set erase(v) {
    this._erase = v;
  }

  get erase() {
    return this._erase;
  }

  set traceErase(v) {
    this._traceErase = v;
  }

  get traceErase() {
    return this._traceErase;
  }

  set steps(v) {
    this._steps = v;
  }

  get steps() {
    return this._steps;
  }
}

cjsTraceDraw.checkGameAction = function (stage, droped) {
  console.log('cjsTraceDraw CHECK');

  let isCorrect = true;

  return isCorrect;
};

cjsTraceDraw.stageMouseDown = function (e, data) {
  console.log('cjsStage DOWN in cjsTraceDraw');

  let stage = data.cjsStage,
    pt = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));
  stage.itemMD = false;

  if (stage.mousedown === true) {
    stage.mousedown = false;
    e.stopPropagation();
    return false;
  }

  let engine = -1;

  for (let gr in stage.groups) {
    for (let id in stage.groups[gr].items) {
      let item = stage.groups[gr].items[id];
      if (item.active !== true) continue;
      engine = item;
    }
  }

  if (engine === -1) {
    console.log('nie znaleziono ITEM');
    e.stopPropagation();
    return false;
  }

  pt.start = true;
  pt.size = engine.point.size;
  pt.color = engine.color;

  engine.mousedown = true;
  engine.trace.push(pt);
  stage.mousedown = true;
  stage.itemMD = { idGroup: engine.idGroup, id: engine.id };

  e.stopPropagation();
};

cjsTraceDraw.stageMouseMove = function (e, data) {
  let stage = data.cjsStage,
    pt = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY)),
    engine = stage.groups[stage.itemMD.idGroup].items[stage.itemMD.id];

  if (stage.mousedown !== true || engine.mousedown !== true) {
    stage.mousedown = false;
    e.stopPropagation();
    return false;
  }

  engine.drawing.graphics
    .ss(engine.point.size, 'round')
    .s(engine.color)
    .mt(engine.trace[engine.trace.length - 1].x, engine.trace[engine.trace.length - 1].y)
    .lt(pt.x, pt.y);

  engine.trace.push(pt);

  engine.drawing.updateCache(engine.erase === true ? 'destination-out' : 'source-over');

  stage.update();
};

cjsTraceDraw.stageMouseUp = function (e, data) {
  console.log('cjsStage UP in cjsTraceDraw');

  let stage = data.cjsStage,
    engine = false,
    pt = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));

  stage.mousedown = false;
  if (stage.itemMD !== false) {
    engine = stage.groups[stage.itemMD.idGroup].items[stage.itemMD.id];
    if (engine instanceof cjsTraceDraw) {
      pt.stop = true;
      engine.trace.push(pt);

      engine.steps.push({
        erase: engine.erase,
        trace: _.cloneDeep(engine.trace),
      });
      engine.trace.splice(0, engine.trace.length);
      engine.mousedown = false;
    }
  }
  stage.itemMD = false;
  cjsTraceDraw.redraw(stage);

  e.stopPropagation();
};

cjsTraceDraw.redraw = function (stage) {
  for (let gr in stage.groups) {
    for (let id in stage.groups[gr].items) {
      let item = stage.groups[gr].items[id];
      if (item.steps.length == 0) {
        continue;
      }
      item.drawing.graphics.clear();
      let size = item.point.size,
        color = item.color;
      for (let j = 0; j < item.steps.length; j++) {
        let step = item.steps[j];
        for (let i = 0; i < step.trace.length; i++) {
          if (i + 1 >= step.trace.length) break;
          if (step.trace[i].start === true) {
            size = step.trace[i].size;
            if (item.panel.multicolor === true) {
              color = step.trace[i].color;
            }
          }
          if (step.trace[i].stop === true) {
            item.drawing.graphics.es();
            continue;
          }
          item.drawing.graphics
            .ss(size, 'round')
            .s(color)
            .mt(step.trace[i].x, step.trace[i].y)
            .lt(step.trace[i + 1].x, step.trace[i + 1].y);

          item.drawing.updateCache(step.erase === true ? 'destination-out' : 'source-over');
          item.drawing.graphics.clear();
        }
      }
    }
  }
};

cjsTraceDraw.resetGameAction = function (stage) {
  console.log('cjsTraceDraw RESET');
  stage._stage.off('mousedown', stage.listener.md);
  stage._stage.off('pressmove', stage.listener.pm);
  stage._stage.off('pressup', stage.listener.pu);
};

cjsTraceDraw.afterLoadSamples = function (stage) {
  console.log('cjsTraceDraw afterLoadSamples');

  cjsDraw.afterLoadSamples(stage);

  for (let gr in stage.groups) {
    for (let id in stage.groups[gr].items) {
      let item = stage.groups[gr].items[id];
      if (item.block === true) continue;
      item._drawing.hitArea = new createjs.Shape(new createjs.Graphics().f('#000').dr(0, 0, stage.width, stage.height));
      item._drawing.cache(0, 0, stage.width, stage.height);
      item._drawing.x -= stage.offset.x;
      item._drawing.y -= stage.offset.y;
      stage._stage.addChild(item.drawing);
    }
  }

  stage._stage.listener = {
    md: stage._stage.on('mousedown', cjsTraceDraw.stageMouseDown, null, false, {
      cjsStage: stage,
    }),
    pm: stage._stage.on('pressmove', cjsTraceDraw.stageMouseMove, null, false, {
      cjsStage: stage,
    }),
    pu: stage._stage.on('pressup', cjsTraceDraw.stageMouseUp, null, false, {
      cjsStage: stage,
    }),
  };
};
